import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class Coupon implements AnalyticsObject {
  name: string
  properties: CouponProperties
  constructor(properties: CouponProperties) {
    this.name = 'Coupon'
    this.properties = properties
  }
}

export interface CouponProperties extends AnalyticsProperties {
  providerSlug?: string
  couponCopy: {
    location: string
    id?: string
    label: string
    type: string
  }
  vacVertical?: string
  vacFirstItem?: string
  vacNbOfResults?: number | null
  vacResultItem?: string | string[]
  vacResultRank?: number
  vacFilters?: Record<string, string | string[]> | null
  vacResultSpotlightProvider?: string
  vacResultSpotlightPlan?: string
}
